import React from 'react'
import * as ePub from 'epubjs/dist/epub'
import axios from 'axios'
import {
  setBookLoadingProgress, setBookReady, setPageCount, setCurrPage, setChapters,
  setOpenAddNote, highlightAction, addNote, updateReadPosition, setDefaultBookFont,
  appearenceTextFont, setFullscreenMode, setInBookmarks, setEditNoteText, setSearchResult, setCurrChapter,
  setSelection, addPrevState, removePrevState, replaceState, deleteNote, updateNote, appearenceTextSize,
  setSelectedNote
} from '../../../actions/reader'
import { connect } from "react-redux";
import { compose, setDisplayName, withStateHandlers } from 'recompose'
import {
  getStateIndex, dateForSaveNote, closePopups, onMouseUp,
  notChildren, getWidthByFontSize
} from '../../../utilities/utilities'
import {createBookID, doChapterSearch, createCfiRange, getCfi} from "../../../utilities/epubUtilities";
import { highlightColors, SERVER, CLOUD_URL, bgColors, googleFontLink, fontSizes, BOOKMARK_TEXT_LIMIT } from "../../../constants"
import {Pagination} from "../../Reader/components/Pagination/Pagination";

import noteIcon from "../../../assets/icons/comments.svg"

import './EpubReader.css'

import { Navigation } from "../../Reader/components/Navigation/Navigation";
import { HighlightModal } from "../../Reader/components/HighlighModal/HighlightModal";
import {nextDropdown} from "../../../actions/dropdown";
import * as Mark from "mark.js";
import * as $ from 'jquery'

const mapStateToProps = (state) => ({
  bookData: state.reader.book,
  bookInfo: state.reader.bookInfo,
  bookUrl: state.reader.bookUrl,
  textColor: state.appearence.color,
  textSize: state.appearence.size,
  textFont: state.appearence.font,
  textFlow: state.appearence.flow,
  highlights: state.reader.highlights,
  bookId: state.reader.bookId,
  userData: state.reader.userData,
  currPage: state.reader.currPage,
  pageCount: state.reader.pageCount,
  activeHighlight: state.reader.activeHighlight,
  bookmarks: state.reader.bookmarks,
  openAddNote: state.reader.openAddNote,
  language: state.userData.language,
  access_token: state.reader.userData.access_token,
  refresh_token: state.reader.userData.refresh_token,
  prevStates: state.reader.prevStates,
  chapters: state.reader.chapters,
  bookReady: state.reader.bookReady,
  selectedNote: state.reader.selectedNote,
  isSampleMode: state.reader.isSampleMode
})

const mapDispatchToProps = (dispatch) => ({
  setBookLoadingProgress: (progress) => dispatch(setBookLoadingProgress(progress)),
  setBookReady: (status) => dispatch(setBookReady(status)),
  setPageCount: (count) => dispatch(setPageCount(count)),
  setCurrPage: (page) => dispatch(setCurrPage(page)),
  setChapters: (chapters) => dispatch(setChapters(chapters)),
  setOpenAddNote: (status) => dispatch(setOpenAddNote(status)),
  toggleActiveHighlight: (status) => dispatch(highlightAction(status)),
  addNote: (note, path, isHighlight) => dispatch(addNote(note, path, isHighlight)),
  updateReadPosition: (read_position, id) => dispatch(updateReadPosition(read_position, id)),
  setDefaultBookFont: (font) => dispatch(setDefaultBookFont(font)),
  setFont: (font) => dispatch(appearenceTextFont(font)),
  setFullscreenMode: (status) => dispatch(setFullscreenMode(status)),
  setInBookmarks: (status) => dispatch(setInBookmarks(status)),
  nextDropdown: (id) => dispatch(nextDropdown(id)),
  setEditNoteText: (text) => dispatch(setEditNoteText(text)),
  setSearchResult: (result) => dispatch(setSearchResult(result)),
  setCurrChapter: (chapter) => dispatch(setCurrChapter(chapter)),
  setSelection: (selection, date) => dispatch(setSelection(selection, date)),
  addPrevState: (page, location, index) => dispatch(addPrevState(page, location, index)),
  removePrevState: () => dispatch(removePrevState()),
  replaceState: (state, index) => dispatch(replaceState(state, index)),
  deleteNote: (id, path, type ) => dispatch(deleteNote(id, path, type )),
  updateNote: (id, note, path) => dispatch(updateNote(id, note, path)),
  setSize: (size) => dispatch(appearenceTextSize(size)),
  setSelectedNote: (note) => dispatch(setSelectedNote(note))
})

const state = {
  book: {},
  rendition: {},
  selectedRange: '',
  selectedHighlightColor: 'yellow',
  selectedText: '',
  selectedHighlight: '',
  rangeRef: '',
  reloading: false,
  searchRequest: '',
  backButton: {
    status: false,
    page: 1,
    location: 0
  },
  forwardButton: {
    status: false,
    page: 1,
    location: 0
  },
  stateIndex: 0
}

const stateHandlers = {
  onSaveReaderPosition: ({rendition, book}, {updateReadPosition, bookId, isSampleMode}) => (closeReader = false) => {
    if (isSampleMode) return

    if (!rendition && !rendition.manager && !rendition.currentLocation()) return
    let currentLocation = 0
    let currentPosition = 0
    let percentage = 0

    try {
      currentLocation = rendition.currentLocation().start.cfi
      currentPosition = book.locations.percentageFromCfi(currentLocation)
      percentage = Math.ceil(currentPosition*100)
    } catch (e) {
      console.log('onSaveReaderPosition', e)
    }

    const read_position = {
      offs: percentage,
      pointer_pb: '#' + currentLocation,
      pointer: '#' + currentLocation
    }

    updateReadPosition(read_position, bookId)

    if (closeReader) {
      setTimeout(() => {
        window.location = CLOUD_URL
      }, 1500)
    }
  },
  onAddBookMark: ({ rendition, book }, {setInBookmarks, bookmarks, bookId, addNote}) => () => {
    const range = rendition.currentLocation().start.cfi

    let isNew = true
    let note = {
      type: {
        value: "bookmark",
        updated: dateForSaveNote()
      },
      mark: {
        anchor: '#' + range,
        created:  Math.round(new Date() / 1000),
        updated: dateForSaveNote()
      },
      quotation: {
        begin: '#' + range,
        end: '#' + range,
        text: '',
        updated: dateForSaveNote()
      }
    }

    for (let i=0; i < bookmarks.length; i++) {
      let bookmark = bookmarks[i]
      if (bookmark.mark.anchor === note.mark.anchor) {
        isNew = false
      }
    }

    if (isNew) {
      addNote(note, bookId)
      setInBookmarks(true)
    }
    window.getSelection().removeAllRanges()
  },
  onDeleteNote: ({rendition, selectedRange, selectedHighlight}, { selectedNote, highlights, bookId, deleteNote }) => (note, isHighlight = false) => {
    if (!note && Object.keys(selectedNote).length > 0) {
      note = selectedNote
      isHighlight = true
    }

    if ( note ) {
      if ( isHighlight ) {
        let cfiRange = createCfiRange(note)

        if (!note.uuid) {
          highlights.map(h => {
            if (h.quotation.begin === note.quotation.begin &&
                h.quotation.end === note.quotation.end) {
              note.uuid = h.uuid
            }
            return h
          })
        }

        deleteNote(note.uuid, bookId, true)

        if (!cfiRange) return

        rendition.annotations.remove(cfiRange, 'mark')
        rendition.annotations.remove(cfiRange, 'highlight')
      } else {
        deleteNote(note.uuid, bookId)
      }
    }
  },
  onLoadHighlight: ({rendition, currPage, stateIndex}, {prevStates, addPrevState}) => (cfi) => {
    cfi = getCfi(cfi)
    let prevCfi = false
    try {
      prevCfi = rendition.currentLocation().start.cfi
    } catch (e) {}
    if(cfi && prevCfi) {
      let index = getStateIndex(prevStates, {page: currPage, location: prevCfi})
      let statePage = index > 0 ? currPage +'-'+ index : currPage
      addPrevState(statePage, prevCfi, stateIndex)
      if (stateIndex === 0) {
        window.history.replaceState({page: statePage, location: prevCfi}, null,
          document.URL);
      }
      window.history.pushState({page: statePage, location: prevCfi}, null,
        document.URL);
      console.log(cfi)
      try {
        rendition.display(cfi)
      } catch (e) {}
      return {
        backButton: {status: true, page: currPage, location: prevCfi},
        forwardButton: {status: false},
        stateIndex: 0
      }
    }
  },
  onLoadBookMark: ({rendition, currPage, stateIndex}, {prevStates, addPrevState}) => (cfi) => {
    cfi = getCfi(cfi)
    let prevCfi = rendition.currentLocation().start.cfi
    if(cfi) {
      let index = getStateIndex(prevStates, {page: currPage, location: prevCfi})
      let statePage = index > 0 ? currPage +'-'+ index : currPage
      addPrevState(statePage, prevCfi, stateIndex)
      if (stateIndex === 0) {
        window.history.replaceState({page: statePage, location: prevCfi}, null,
          document.URL);
      }
      window.history.pushState({page: statePage, location: prevCfi}, null,
        document.URL);
      rendition.display(cfi)
      return {
        backButton: {status: true, page: currPage, location: prevCfi},
        forwardButton: {status: false},
        stateIndex: 0
      }
    }
  },
  onChangePage: ({book, searchRequest, rendition, onAddHighlights, currPage, stateIndex, onAddFontInBook},
                 {prevStates, replaceState, setCurrChapter, setInBookmarks, bookmarks, chapters}) => (location) => {
    if (!rendition || !location) return

    const cfiStart = location.start.cfi
    const currStartLocation = location.start.location
    const currEndLocation = location.end.location

    setInBookmarks(false)

    bookmarks.forEach((bookmark) => {
      let cfi = getCfi(bookmark.mark.anchor)
      if (cfi) {
        let l = false
        try {
          l = rendition.book.locations.locationFromCfi(cfi)
        } catch (e) {
          console.log('onChangePage', e)
        }
        /*if (cfi === cfiStart || cfi === cfiEnd) {
          setInBookmarks(true)
        }*/
        if (l && l >= currStartLocation && l <= currEndLocation) {
          setInBookmarks(true)
        }
      }
    })
    onAddHighlights()

    let sectionHref = ''
    if (cfiStart && rendition.book.spine.get(cfiStart)) {
      sectionHref = rendition.book.spine.get(cfiStart).href
    }
    const getVisibleChapters = (arr, level = -1, parentIndexes = []) => {
      level++
      for (let i=0; i < arr.length; i++) {
        let chapter = arr[i]
        let href = chapter.href.chapterIndex
        if (level === 0) {
          parentIndexes = []
        }
        parentIndexes[level] = i
        if (href === sectionHref) {
          let ids = [href]
          let parent

          for (let l=0; l < parentIndexes.length; l++) {
            let index = parentIndexes[l]
            if (l === 0) {
              parent = chapters[index]
            } else if (parent && parent.subitems) {
              parent = parent.subitems[index]
            }
            if (!parent) continue
            ids.push(parent.href.chapterIndex)
          }
          setCurrChapter(ids)
        }
        if (chapter.subitems.length > 0) {
          getVisibleChapters(chapter.subitems, level, parentIndexes)
        }
      }
    }
    if (sectionHref.length > 0) {
      getVisibleChapters(chapters)
    }

    let contents = rendition.getContents()
    for (let i=0; i < contents.length; i++) {
      let content = contents[i].document.body

      let instance = new Mark(content)
      instance.unmark()

      if (searchRequest.length > 2) {
        instance.mark(searchRequest, {"separateWordSearch": false})
      }
    }

    let page = location.start.location < 1 ? 1 : location.start.location + 1
    let index = getStateIndex(prevStates, {page: page, location: cfiStart})
    let statePage = index > 0 ? page +'-'+ index : page
    if (stateIndex > 0) {
      let indexPage = prevStates[stateIndex].page
      if (indexPage.toString().indexOf('-') > -1) {
        indexPage = indexPage.split('-')[0]
      }
      if (indexPage === page) {
        statePage = indexPage
      } else {
        index = getStateIndex(prevStates, {page: page, location: cfiStart}, 0)
        statePage = index > 0 ? page + '-' + index : page
      }
    }
    replaceState({page: statePage, location: cfiStart}, stateIndex)
    window.history.replaceState({page: statePage, location: cfiStart}, null,document.URL);
    return {
      currPage: page
    }
  },
  onChangeChapter: ({rendition, currPage, stateIndex}, {prevStates, addPrevState, setSearchResult}) => (chapterHref) => {
    let cfi = chapterHref.chapterIndex ? chapterHref.chapterIndex.chapterIndex : chapterHref
    let prevCfi = rendition.currentLocation().start.cfi
    setSearchResult([])
    let index = getStateIndex(prevStates, {page: currPage, location: prevCfi})
    let statePage = index > 0 ? currPage +'-'+ index : currPage
    addPrevState(statePage, prevCfi, stateIndex)
    if (stateIndex === 0) {
      window.history.replaceState({page: statePage, location: prevCfi}, null,
        document.URL);
    }
    window.history.pushState({page: statePage, location: prevCfi}, null,
      document.URL);

    rendition.display(cfi)
    return {
      backButton: {status: true, page: currPage, location: prevCfi},
      forwardButton: {status: false},
      stateIndex: 0
    }
  },
  onChangeViewMode: ({ rendition, onRenderBook }, {textSize, isSampleMode}) => (view, firstLoad = false) => {
    let flow = "paginated"
    let manager = "default"
    let viewer = document.getElementById('viewer')

    switch (view) {
      case '1page':
        flow = "paginated"
        manager = ""
        viewer.classList.remove("large")
        viewer.classList.remove('two-page')
        viewer.classList.remove('scrolling')
        viewer.classList.add('one-page')
        break
      case '2page':
        flow = "paginated"
        manager = ""

        viewer.classList.add("large")
        viewer.classList.add('two-page')
        viewer.classList.remove('scrolling')
        viewer.classList.remove('one-page')
        break
      case 'scrolling':
        flow = "scrolled-continuous"
        manager = "continuous"

        viewer.classList.remove("large")
        viewer.classList.remove('two-page')
        viewer.classList.add('scrolling')
        viewer.classList.remove('one-page')

        break
      default:
        flow = "paginated"
        manager = ""
        viewer.classList.remove("large")
    }

    viewer.style.maxWidth = ''
    if (view !== '2page') {
      let vWidth = getWidthByFontSize(textSize)
      viewer.style.maxWidth = vWidth + 'px'
    }

    let cfi = false

    if (!firstLoad) {
      if (!rendition.location) return
      cfi = rendition.location.start.cfi
    }

   try {
     if (rendition && Object.keys(rendition).length > 0) {
       rendition.destroy()

       if (rendition.book && rendition.manager) return
       if (cfi) {
         onRenderBook(manager, flow, cfi)
       } else {
         onRenderBook(manager, flow)
       }
     } else {
       if (cfi) {
         onRenderBook(manager, flow, cfi)
       } else {
         onRenderBook(manager, flow)
       }
     }
   } catch (e) {
      console.log('onChangeViewMode', e)
   }
  },
  onNextPage: ({ rendition }) => () => {
    try {
      rendition.next()
    } catch (e) {
      console.log('onNextPage', e)
    }
  },
  onArrowPrev: () => (onPrevPage) => {
    onPrevPage()
  },
  onArrowNext: () => (onNextPage) => {
    onNextPage()
  },
  onPrevPage: ({ rendition }) => () => {
    try {
      rendition.prev()
    } catch (e) {
      console.log('onPrevPage', e)
    }
  },
  onLoad: () => (rendition, book) => ({
    rendition: rendition,
    book: book
  }),
  onChangeTextSize: ({ rendition }, {textSize, textFlow, setSize}) => (size) => {
    textSize = parseInt(textSize, 10)
    if (typeof size === 'boolean') {
      let index = fontSizes.indexOf(textSize)
      if (size) {
        let fontSizesLeng = fontSizes.length-1
        index++
        if (index > fontSizesLeng) return
      } else {
        index--
        if (index < 0) return
      }
      size = fontSizes[index]
    }

    let tags = [
      {tag: 'h1', value: 1.8},
      {tag: 'h2', value: 1.6},
      {tag: 'h3', value: 1.5},
      {tag: 'h4', value: 1.4},
      {tag: 'h5', value: 1.3},
      {tag: 'h6', value: 1.2},
      {tag: 'p', value: 1},
      {tag: 'ol', value: 1},
      {tag: 'ul', value: 1},
      {tag: 'table', value: 1},
      {tag: 'span', value: 1},
      {tag: '.calibre', value: 1}
    ]
    let rules = rendition.themes._themes.default.rules
    tags.forEach((tag) => {
      let tTag = tag.tag
      let value = tag.value
      rules[tTag] = rules[tTag] || {}
      rules[tTag]['font-size'] = size*value + 'px !important'
    })

    rules['body'] = rules['body'] || {}
    rules['body']['word-break'] = 'break-word'
    rules['body']['word-wrap'] = 'break-word'

    rules['img'] = rules['img'] || {}
    rules['img']['max-width'] = '100%'

    let viewer = document.getElementById('viewer')
    viewer.style.maxWidth = ''
    if (textFlow !== '2page') {
      let vWidth = getWidthByFontSize(size)
      viewer.style.maxWidth = vWidth + 'px'
    }

    rendition.themes.update('default');
    rendition.onResized({width: '100%', height: '100%'})
    rendition.resize()
    rendition.themes.override('font-size',size+'px', true)

    setSize(size)
  },
  onChangeTextColor: ({ rendition }) => (bgClass) => {
    let textColor = bgClass === 'black' ? '#fff' : '#000';
    let bgColor = bgClass === 'black' ? '#000' : bgColors[bgClass].bg
    let tags = ['body', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ol', 'ul', 'table']
    let rules = {}
    let invert = bgClass === 'black' ? 1 : 0

    tags.forEach((tag) => {
      rules[tag] = {
        color: textColor + '!important',
        'background-color': bgColor + '!important'
      }
    })
    rules['p'] = {
      color: textColor + '!important',
      'background-color': 'transparent !important'
    }
    rules['img'] = {
      filter: 'invert('+invert+')'
    }
    rules['.reset '] = bgClass === 'black' ?
      {color: '#fff'} : {color: '#010000'}

    rendition.themes.register(bgClass, rules);
    rendition.themes.select(bgClass);
    document.getElementsByTagName('body')[0].className = bgClass
  },
  onChangeTextFont: ({ rendition }) => (font) => {
    let tags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'ol', 'ul', 'table', 'div']
    let rules = rendition.themes._themes.default.rules

    tags.forEach((tag) => {
      rules[tag] = rules[tag] || {}
      rules[tag]['font-family'] = font + '!important'
      rules[tag]['line-height'] = 1.42 + '!important'
    })
    rules['.galley-rw'] = {
      'position': 'static !important'
    }
    rules['svg'] = {
      'max-height': 'none !important'
    }

    rendition.themes.update('default');
    rendition.onResized({width: '100%', height: '100%'})
  },
  onAddFontInBook: ({rendition}) => () => {
    let rules = rendition.themes._themes.default.rules
    rules['@import'] = googleFontLink;
    rendition.themes.update('default');
  },
  onAddHighlights: ({rendition, onSelected, changeHighlighModalPosition},
                    {setSelection, highlights, setEditNoteText, toggleActiveHighlight, activeHighlight, setOpenAddNote,
                      setSelectedNote}) => () => {
    if (!highlights) return

    try {
      highlights.forEach(highlight => {
        let cfiRange = createCfiRange(highlight)
        if (cfiRange) {
          rendition.annotations.remove(cfiRange, 'mark')
          rendition.annotations.remove(cfiRange, 'highlight')
        }
      })
    } catch (e) {
      console.log('onAddHighlights - remove old highlights', e)
    }

    highlights.forEach((highlight) => {
      if (!highlight.quotation || !highlight.quotation.begin) return

      let cfiRange = createCfiRange(highlight)
      if (!cfiRange) return

      let data = {text: highlight.quotation.text, uuid: highlight.uuid}
      let color

      if(highlight.note) {
        data.note = highlight.note.text
        data.styles = {
          'background-image': 'url(' + noteIcon + ')',
          'width': '23px',
          'height': '23px',
          'margin': '-3px 0 0',
          'z-index': 2,
          'background-position': 'center center',
          'background-size': 'cover',
          'cursor': 'pointer'
        }

        try {
          rendition.annotations.add('mark', cfiRange, data, (e) => {
            setEditNoteText(data.note)
            onSelected(cfiRange, highlight.quotation.text, highlight.uuid)
            setSelectedNote(highlight)
            let openClass = 'openEditNote'
            onMouseUp(e, changeHighlighModalPosition, toggleActiveHighlight, activeHighlight, onSelected, setOpenAddNote, openClass, true)
          })
        } catch(e) {
          console.log('onAddHighlights - addMark', e)
        }
        color = highlightColors[highlight.color ? highlight.color.value : 'red']
      } else {
        color = highlightColors[highlight.color ? highlight.color.value : 'yellow']
      }
      try {
        rendition.annotations.highlight(cfiRange, data, (e) => {
          let cfi = e.target.dataset.epubcfi
          setSelection(cfi, dateForSaveNote())
          onSelected(cfi, e.target.dataset.text, e.target.dataset.uuid)
          setSelectedNote(highlight)
        }, '', {fill: color, 'fill-opacity': 0.3 })
      } catch(e) {
        console.log('onAddHighlights - addHighlight', e)
      }
    })
  },
  onSelected: () => (range = '', text = '', uuid = '') => (
      {selectedRange: range, selectedText: text, selectedHighlight: uuid}
  ),
  onLoadChapters: () => (book, setChapters) => {
    if (!book) return

    const loadChapters = (arr) => {
        for (let i=0; i < arr.length; i++) {
          let chapter = arr[i]
          let label = chapter.label.trim()

          if (label.length > 0) {
            let section = book.section(chapter.href) || book.section('Text/' + chapter.href) ||
              book.section('xhtml/' + chapter.href)
            section.load(book.load.bind(book)).then(() => {
              let el = section.document.getElementById(section.idref)
              let cfi = section.cfiFromElement(el)
              let href = chapter.href
              chapter.href = {
                page: cfi ? cfi : 0,
                chapterIndex: href
              }
              chapter.page = chapter.href.page !== 0 ? book.locations.locationFromCfi(chapter.href.page) + 1 : 1
            }).finally(section.unload.bind(section))
          }

          if ( chapter.subitems.length > 0 ) {
            loadChapters(chapter.subitems)
          }
        }

        return arr
    }

    book.loaded.navigation.then((toc) => {
      let chapters = loadChapters(toc.toc)
      setChapters(chapters)
    })
  },
  onAddRangeRef: () => (ref) => (
      {rangeRef: ref}
  ),
  onAddNote: ({rendition, selectedRange, selectedHighlightColor, selectedText}, {updateNote, selectedNote,
    setSelection, bookId, addNote, setSelectedNote, highlights}) => (onSelected, isUpdate) => {
    let note = {}
    if (isUpdate) {
      note = selectedNote

      note.color.value = selectedHighlightColor
      note.color.updated = dateForSaveNote()

      if (!note.uuid) {
        highlights.forEach(highlight => {
          if (highlight.quotation.begin === note.quotation.begin &&
            highlight.quotation.end === note.quotation.end) {
            note.uuid = highlight.uuid
          }
        })
      }

      updateNote(note.uuid, note, bookId)
      setSelectedNote(note)
      rendition.annotations.remove(selectedRange, 'highlight')
    } else {
      const range = selectedRange.split(',')

      note = {
        type: {
          value: "highlight",
          updated: dateForSaveNote()
        },
        color: {
          value: selectedHighlightColor,
          updated: dateForSaveNote()
        },
        mark: {
          anchor: '#' + range[0] + range[1] + ')',
          created:  Math.round(new Date() / 1000),
          updated: dateForSaveNote()
        },
        quotation: {
          begin: '#' + range[0] + range[1] + ')',
          end: '#' + range[0] + range[2],
          text: selectedText.substr(0, BOOKMARK_TEXT_LIMIT),
          updated: dateForSaveNote()
        }
      }

      if(selectedRange !== '' && selectedText.length > 0) {
        addNote(note, bookId, true)
      }
    }

    if(selectedRange !== '' && selectedText.length > 0) {
      rendition.annotations.highlight(selectedRange, {text: note.quotation.text}, (e) => {
        let cfi = $(e.target).attr('data-epubcfi')
        let text = $(e.target).attr('data-text')
        setSelection(cfi, dateForSaveNote())
        onSelected(cfi, text, '')
        setSelectedNote(note)
      }, '', {fill: highlightColors[selectedHighlightColor], 'fill-opacity': .3})
    }
    let contents = rendition.getContents()
    for(let i=0;i<contents.length;i++) {
      let content = contents[i]
      content.window.getSelection().removeAllRanges()
    }
  },
  onUpdateNote: ({rendition, selectedHighlight, selectedRange, selectedText, selectedHighlightColor},
                 {selectedNote, setSelection, highlights, setOpenAddNote, toggleActiveHighlight, activeHighlight, setEditNoteText,
                   bookId, addNote, updateNote, setSelectedNote}) =>
      (noteText, onSelected, changeHighlighModalPosition) => {

      let markStyles = {
        'background-image': 'url(' + noteIcon + ')',
        'width': '23px',
        'height': '23px',
        'margin': '-3px 0 0',
        'z-index': 2,
        'background-position': 'center center',
        'background-size': 'cover',
        'cursor': 'pointer'
      }

      let note = {}
      let color = 'red'

      if (Object.keys(selectedNote).length > 0) {
        note = selectedNote
        color = note.color.value
        note.type = {
          value: "note",
          updated: dateForSaveNote()
        }
        note.note = {
          text: noteText.substr(0, BOOKMARK_TEXT_LIMIT),
          updated: dateForSaveNote()
        }

        if (!note.uuid) {
          highlights.forEach(highlight => {
            if (highlight.quotation.begin === note.quotation.begin &&
              highlight.quotation.end === note.quotation.end) {
              note.uuid = highlight.uuid
            }
          })
        }

        updateNote(note.uuid, note, bookId)

        rendition.annotations.remove(selectedRange, 'highlight')
        rendition.annotations.remove(selectedRange, 'mark')
      } else {
        const range = selectedRange.split(',')

        note = {
          color: {
            value: color,
            updated: dateForSaveNote()
          },
          type: {
            value: "note",
            updated: dateForSaveNote()
          },
          note: {
            text: noteText.substr(0, BOOKMARK_TEXT_LIMIT),
            updated: dateForSaveNote()
          },
          mark: {
            anchor: '#' + range[0] + range[1] + ')',
            created:  Math.round(new Date() / 1000),
            updated: dateForSaveNote()
          },
          quotation: {
            begin: '#' + range[0] + range[1] + ')',
            end: '#' + range[0] + range[2],
            text: selectedText.substr(0, BOOKMARK_TEXT_LIMIT),
            updated: dateForSaveNote()
          }
        }

        addNote(note, bookId, true)
      }

      let data = {}
      data.note = note.note.text
      data.styles = markStyles
      rendition.annotations.add('mark', selectedRange, data, (e) => {
        setEditNoteText(data.note)
        onSelected(selectedRange, note.quotation.text)
        setSelectedNote(note)
        let openClass = 'openEditNote'
        onMouseUp(e, changeHighlighModalPosition, toggleActiveHighlight, activeHighlight, onSelected, setOpenAddNote, openClass, true)
      })
      rendition.annotations.highlight(selectedRange, {text: note.quotation.text}, (e) => {
        let cfi = $(e.target).attr('data-epubcfi')
        let text = $(e.target).attr('data-text')
        setSelection(cfi, dateForSaveNote())
        setSelectedNote(note)
        onSelected(cfi, text, '')
      }, '', {fill: highlightColors[color], 'fill-opacity': .3})

      let contents = rendition.getContents()
      for(let i=0;i<contents.length;i++) {
        let content = contents[i]
        content.window.getSelection().removeAllRanges()
      }
  },
  onSelectedColor: () => (color) => (
      {selectedHighlightColor: color}
  ),
  onSetTextSelected: ({rendition}) => (color) => {
    let contents = rendition.getContents()

    let tags = ['::selection']
    let rules = {}
    tags.forEach((tag) => {
      rules[tags] = {
        background: color
      }
    })
    rendition.themes._themes.default.rules = rules
    contents.forEach(function (content) {
      rendition.themes.add('default', content)
    })
  },
  onChangeStart: () => (value) => ({
    pageOnChangeStart: value
  }),
  onChangeRange: () => (value) => ({
    currPage: value
  }),
  onChangeRangeComplete: ({rendition, rangeRef, currPage, pageOnChangeStart, stateIndex}, {prevStates, addPrevState, pageCount}) => {
    return (value) => {
      if (!rendition) return

      const percent = value * 100 / pageCount
      const cfi = rendition.book.locations.cfiFromPercentage(percent / 100);
      const prevPercent = pageOnChangeStart * 100 / pageCount
      const prevCfi = rendition.book.locations.cfiFromPercentage(prevPercent / 100);

      let index = getStateIndex(prevStates, {page: pageOnChangeStart, location: prevCfi})
      let statePage = index > 0 ? pageOnChangeStart + '-' + index : pageOnChangeStart
      addPrevState(statePage, cfi, stateIndex)
      if (stateIndex === 0) {
        window.history.replaceState({page: statePage, location: prevCfi}, null,
          document.URL);
      }
      window.history.pushState({page: statePage, location: prevCfi}, null,
        document.URL);
      rendition.display(value === 1 ? 0 : cfi)
      return {
        currPage: value,
        backButton: {status: true, page: pageOnChangeStart, location: prevCfi},
        forwardButton: {status: false},
        stateIndex: 0
      }
    };
  },
  onSearch: ({book, rendition}, {setSearchResult}) => (e, value) => {
    if (!rendition) return

    let q = ''
    if (!e) {
      q = value
    } else {
      q = e.target.value
    }

    let contents = rendition.getContents()
    for (let i=0; i < contents.length; i++) {
      let content = contents[i].document.body

      let instance = new Mark(content)
      instance.unmark()

      if (q.length > 2) {
        instance.mark(q, {"separateWordSearch": false})
      }
    }

    if (q.length > 2) {
      Promise.all(
          book.spine.spineItems.map(item => item.load(book.load.bind(book)).then(item.find.bind(item, q)).finally(item.unload.bind(item)))
      ).then(results => {
        results = [].concat.apply([], results)
        results = results.map((item) => {
          let chapter = doChapterSearch(book, rendition, item.cfi)
          let chapterTitle = chapter ? chapter.label.trim() : ''
          let page = book.locations.locationFromCfi(item.cfi) + 1
          return {range: item.cfi, text: item.excerpt, chapterTitle: chapterTitle, page: page}
        })
        setSearchResult(results)
      })
    } else {
      setSearchResult([])
    }

    return {searchRequest: q}
  },
  setOnAddHighlights: () => (onAddHighlights) => ({
    onAddHighlights: onAddHighlights
  }),
  setBookData: () => (data) => ({
    bookData: data
  }),
  addState: ({currPage, rendition, stateIndex}, {prevStates, addPrevState}) => () => {
    let linkCfi = rendition.currentLocation().start.cfi
    let index = getStateIndex(prevStates, {page: currPage, location: linkCfi})
    let statePage = index > 0 ? currPage +'-'+ index : currPage
    addPrevState(statePage, linkCfi, stateIndex)
    if (stateIndex === 0) {
      window.history.replaceState({page: statePage, location: linkCfi}, null,
          document.URL);
    }
    window.history.pushState({page: statePage, location: linkCfi}, null,
        document.URL);
    return {
      backButton: {status: true, page: currPage, location: linkCfi},
      forwardButton: {status: false},
      stateIndex: 0,
    }
  },
  setAddState: () => (addState) => ({
    addState: addState
  }),
  onRenderBook: ({ addState, bookData, onLoad, onAddFontInBook, onChangeTextColor, onChangeTextSize, onChangeTextFont,
                   onChangeViewMode, onSelected, onAddHighlights, onChangePage, onSaveReaderPosition, onLoadChapters,
                   changeHighlighModalPosition, onArrowPrev, onArrowNext, onPrevPage, onNextPage, currPage,
                   onOpenHighlightModal },
                 { textFlow, setSearchResult, nextDropdown, setCurrPage, setSelectedNote,
                   setPageCount, bookInfo, textColor, textSize, toggleActiveHighlight,
                   textFont, setChapters, isSampleMode}) => (manager, flow, currCfi) => {
    let book = ePub();
    book.open(bookData)

    let options = {
      width: "100%",
      height: "100%"
    }
    if (textFlow !== '2page') {
      options.minSpreadWidth = '2000'
    }

    if (manager || manager.length > 0) {
      options.manager = manager
    }
    if (flow) {
      options.flow = flow
    }

    const rendition = book.renderTo("viewer", options)
    rendition.onResized({height: '100%', width: '100%'})
    let cfi = false
    if (currCfi) {
      cfi = currCfi
    } else if (!isSampleMode && bookInfo.position.pointer_pb) {
      cfi = getCfi(bookInfo.position.pointer_pb)
      if (!cfi && bookInfo.position.pointer) cfi = getCfi(bookInfo.position.pointer)
    }

    let displayed = cfi ? rendition.display(cfi) : rendition.display()

    let addEvents = false

    book.ready.then(() => {
      onLoad(rendition, book)

      displayed.then(() => {
        onAddFontInBook()

        let wait = setInterval(() => {
          if (rendition.currentLocation() && rendition.currentLocation().start && rendition.currentLocation().start.location > 0) {
            setCurrPage(rendition.currentLocation().start.location)
            onChangePage(rendition.currentLocation())
            addEvents = true
            clearInterval(wait)
          }
        }, 200)

        onChangeTextColor(textColor)
        onChangeTextFont(textFont)
        onChangeTextSize(textSize)

        onAddHighlights()
      })

      const title = rendition.book.packaging.metadata.title
      const key = createBookID(title)
      const stored = localStorage.getItem(key)
      if ( stored ) {
        return book.locations.load(stored);
      } else {
        return book.locations.generate(2048);
      }
    }).then(() => {
      const title = rendition.book.packaging.metadata.title
      setPageCount(book.locations._locations.length)
      localStorage.setItem(createBookID(title), book.locations.save())
      onLoad(rendition, book)
      onLoadChapters(book, setChapters, true)
    })
    onLoadChapters(book, setChapters)

    rendition.on("selected", (cfiRange) => {
      book.getRange(cfiRange).then(function (range) {
        if (range) {
          const text = range.toString();
          const cfi = cfiRange

          onSelected(cfi, text)
        }
      })
    })

    let drag = false
    rendition.on('mousedown', (e) => {
      e.stopPropagation()
      rendition.getContents().forEach((content) => {
        closePopups(content.document, nextDropdown)
      })
      onSelected('')
      setSelectedNote({})
      setSearchResult([])
      drag = false

      let marks = []
      let popup = []
      notChildren(marks, e.target, document.getElementsByClassName('mark'))
      notChildren(popup, e.target, document.getElementById('HighlightModal__wrapper'))
      if (!(popup.indexOf(false)> -1) && !(marks.indexOf(false) > -1)) {
        toggleActiveHighlight(false)
        let marks = document.getElementsByClassName('mark')
        for (let i=0; i< marks.length; i++) {
          let mark = marks[i]
          mark.classList.remove('open')
        }
      }
      if ((e.target && e.target.tagName.toLowerCase() === 'a')  || (e.target && e.target.parentElement && e.target.parentElement.tagName.toLowerCase() === 'a')) {
        addState()
      }
    })
    rendition.on('mousemove', () => {
      drag = true
    })
    let wait

    rendition.on('mouseup', (e) => {
      if (wait) clearInterval(wait)
      let selected = ''

      rendition.getContents().forEach((content) => {
        let text = content.window.getSelection().toString()
        if (text.length > 0) selected = text
      })
      onOpenHighlightModal(e, drag, selected)
    })

    rendition.on('keydown', (e) => {
      e = e || window.event

      if (e.keyCode === 38 || e.keyCode === 37 || e.keyCode === 33) {
        onArrowPrev(onPrevPage)
      }
      else if (e.keyCode === 40 || e.keyCode === 39 || e.keyCode === 34) {
        onArrowNext(onNextPage)
      }
    })

    rendition.on("relocated", (location) => {
      if (addEvents) {
        onChangePage(location)
        onSaveReaderPosition()
      }
    })

    return {reloading: false}
  },
  onOpenHighlightModal: ({changeHighlighModalPosition, onSelected, selectedRange}, {setSearchResult, toggleActiveHighlight,
    activeHighlight, setOpenAddNote}) => (e, drag, selected) => {
    let node = e.target ? e.target.tagName.toLowerCase() : null
    let parentNode = e.target && e.target.parentElement ? e.target.parentElement.tagName.toLowerCase() : null

    if ((node === 'a' && e.target.href)  || (parentNode === 'a' && e.target.parentElement.href)) {
      toggleActiveHighlight(false)
    } else if (drag && selected.length > 0) {
      setSearchResult([])
      if (!e.target.href || node !== 'a') {
        onMouseUp(e, changeHighlighModalPosition, toggleActiveHighlight,
          activeHighlight, onSelected, setOpenAddNote, '', null, true, drag)
      }
    } else if (selectedRange && selectedRange.length > 0) {
      setSearchResult([])
      onMouseUp(e, changeHighlighModalPosition, toggleActiveHighlight,
        activeHighlight, onSelected, setOpenAddNote, 'openEditHighlight', null, true, drag)
    } else {
      toggleActiveHighlight(false)
    }
  },
  goBack: ({rendition, stateIndex, changeIndex}, {prevStates}) => (e) => {
    if (!e.state || !e.state.page || prevStates.length <= 1) {
      window.location = CLOUD_URL
      return
    }

    let state = e.state
    let page = state.page.toString()
    if (page.indexOf('-') > -1) page = page.split('-')[0]
    let cfi = state.location
    let currIndex = 0

    for (let i=0; i < prevStates.length; i++) {
      let prevState = prevStates[i]
      let prevPage = prevState.page.toString()
      if (state.page.toString() === prevPage) {
        currIndex = i
        break
      }
    }

    let forwardButton = {status: false}
    if (currIndex !== 0) {
      forwardButton.status = true
      forwardButton.page = prevStates[currIndex-1].page
      if (forwardButton.page.toString().indexOf('-') > -1) {
        forwardButton.page = forwardButton.page.toString().split('-')[0]
      }
      forwardButton.location = prevStates[currIndex-1].location
    }
    let backButton = {status: false}
    if (currIndex !== (prevStates.length-1)) {
      backButton.status = true
      backButton.page = prevStates[currIndex+1].page
      if (backButton.page.toString().indexOf('-') > -1) {
        backButton.page = backButton.page.toString().split('-')[0]
      }
      backButton.location = prevStates[currIndex+1].location
    }

    changeIndex(currIndex)
    rendition.display(cfi)

    return {
      currPage: page,
      forwardButton: forwardButton,
      backButton: backButton
    }
  },
  changeIndex: () => (index) => ({
    stateIndex: index,
  }),
  setChangeIndex: () => (changeIndex) => ({
    changeIndex: changeIndex
  }),
  onBackButton: () => () => {
    window.history.back()
  },
  onForwardButton: () => () => {
    window.history.forward()
  },
  setOnLoad: () => (onLoad) => ({
    onLoad: onLoad
  }),
  setOnAddFontInBook: () => (onAddFontInBook) => ({
    onAddFontInBook: onAddFontInBook
  }),
  setOnChangeTextColor: () => (onChangeTextColor) => ({
    onChangeTextColor: onChangeTextColor
  }),
  setOnChangeTextSize: () => (onChangeTextSize) => ({
    onChangeTextSize: onChangeTextSize
  }),
  setOnChangeTextFont: () => (onChangeTextFont) => ({
    onChangeTextFont: onChangeTextFont
  }),
  setOnChangeViewMode: () => (onChangeViewMode) => ({
    onChangeViewMode: onChangeViewMode
  }),
  setOnRenderBook: () => (onRenderBook) => ({
    onRenderBook: onRenderBook
  }),
  setOnSelected: () => (onSelected) => ({
    onSelected: onSelected
  }),
  setOnArrowNext: () => (onArrowNext) => ({
    onArrowNext: onArrowNext
  }),
  setOnArrowPrev: () => (onArrowPrev) => ({
    onArrowPrev: onArrowPrev
  }),
  setOnNextPage: () => (onNextPage) => ({
    onNextPage: onNextPage
  }),
  setOnPrevPage: () => (onPrevPage) => ({
    onPrevPage: onPrevPage
  }),
  setOnSaveReaderPosition: () => (onSaveReaderPosition) => ({
    onSaveReaderPosition: onSaveReaderPosition
  }),
  setOnChangePage: () => (onChangePage) => ({
    onChangePage: onChangePage
  }),
  setOnLoadChapters: () => (onLoadChapters) => ({
    onLoadChapters: onLoadChapters
  }),
  setChangeHighlighModalPosition: () => (changeHighlighModalPosition) => ({
    changeHighlighModalPosition: changeHighlighModalPosition
  }),
  setOnOpenHighlightModal: () => (onOpenHighlightModal) => ({
    onOpenHighlightModal: onOpenHighlightModal
  })
}

export const enhance = compose(
    setDisplayName('Epub Reader'),
    connect(mapStateToProps, mapDispatchToProps),
    withStateHandlers(state, stateHandlers)
)

export class View extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      highlightModalTop: 0,
      highlightModalLeft: 0
    }

    this.changeHighlighModalPosition = this.changeHighlighModalPosition.bind(this)
  }

  changeHighlighModalPosition(top, left) {
    this.setState({highlightModalTop: top, highlightModalLeft: left})
  }

  componentDidMount () {
    const { props: { bookInfo, bookUrl, setBookReady, setBookLoadingProgress,
      onChangeTextColor, onChangeTextSize, onChangeTextFont, onChangeViewMode,
      onLoad, onAddFontInBook, setOnSelected,
      onAddHighlights, onSelected, onLoadChapters, onChangePage, setOpenAddNote, onSaveReaderPosition,
      toggleActiveHighlight,
      setFullscreenMode, nextDropdown, onArrowPrev, onArrowNext, onNextPage, onPrevPage,
      setSearchResult, setOnAddHighlights, setBookData, onRenderBook, setOnLoad,
      setOnAddFontInBook, setOnChangeTextColor, setOnChangeTextSize,
      setOnChangeTextFont, setOnChangeViewMode, setOnRenderBook, setOnChangePage,
      setOnSaveReaderPosition, setOnLoadChapters, setChangeHighlighModalPosition, textFlow,
      setOnNextPage, setOnPrevPage, access_token, setOnArrowPrev, setOnArrowNext, goBack,
      setAddState, addState, setChangeIndex, changeIndex, setOnOpenHighlightModal,
      onOpenHighlightModal, isSampleMode }} = this

    setOnAddHighlights(onAddHighlights)
    setOnLoad(onLoad)
    setOnAddFontInBook(onAddFontInBook)
    setOnChangeTextColor(onChangeTextColor)
    setOnChangeTextSize(onChangeTextSize)
    setOnChangeTextFont(onChangeTextFont)
    setOnChangeViewMode(onChangeViewMode)
    setOnRenderBook(onRenderBook)
    setOnSelected(onSelected)
    setOnChangePage(onChangePage)
    setOnSaveReaderPosition(onSaveReaderPosition)
    setOnLoadChapters(onLoadChapters)
    setOnNextPage(onNextPage)
    setOnPrevPage(onPrevPage)
    setOnArrowPrev(onArrowPrev)
    setOnArrowNext(onArrowNext)
    setAddState(addState)
    setChangeIndex(changeIndex)
    setChangeHighlighModalPosition(this.changeHighlighModalPosition)
    setOnOpenHighlightModal(onOpenHighlightModal)

    window.history.replaceState({'status': 'loaded'}, null, document.URL);
    window.history.pushState({'status': 'loaded'}, null, document.URL);

    let config = {
      responseType: 'arraybuffer',
      onDownloadProgress: progressEvent => {
        let progress = Math.ceil((progressEvent.loaded*100)/progressEvent.total)
        setBookLoadingProgress(progress)
      }
    }

    if (isSampleMode) {
      config.headers = {
        "Access-Control-Allow-Origin": "*"
      }
    }

    let url = bookUrl
    if (bookInfo.isDrm || bookInfo.isLcp) {
      url = SERVER + '/api/v1.0/reader/decoded-file/' + bookInfo.hash + '?access_token=' + access_token
    }

    axios.get(url, config).then(res => {
      setBookReady(true)
      setBookData(res.data)
      onChangeViewMode(textFlow, true)

      let fullscreenStatus = false
      const toggleFullscreen = () => {
        setFullscreenMode(!fullscreenStatus)
        fullscreenStatus = !fullscreenStatus
        const root = document.getElementById('root')
        if (root) root.classList.toggle('fullscreen')
      }

      if (document.addEventListener) {
        document.addEventListener('webkitfullscreenchange', toggleFullscreen, false);
        document.addEventListener('mozfullscreenchange', toggleFullscreen, false);
        document.addEventListener('fullscreenchange', toggleFullscreen, false);
        document.addEventListener('MSFullscreenChange', toggleFullscreen, false);

        if (!isSampleMode) {
          document.addEventListener("mouseup", (e) => {
            let flags = []
            let search = document.getElementsByClassName('Search')[0]
            if (search) notChildren(flags, e.target, search.children)
            if (!(flags.indexOf(false) > -1)) {
              setSearchResult([])
            }
            let marks = []
            let popup = []
            notChildren(marks, e.target, document.getElementsByClassName('mark'))
            notChildren(popup, e.target, document.getElementById('HighlightModal__wrapper').children)

            if (!(popup.indexOf(false) > -1) && !(marks.indexOf(false) > -1)) {
              toggleActiveHighlight(false)
              setOpenAddNote('')

              let marks = document.getElementsByClassName('mark')
              for (let i = 0; i < marks.length; i++) {
                let mark = marks[i]
                mark.classList.remove('open')
              }
            }
          })

          closePopups(document, nextDropdown)
        }

        document.addEventListener('keydown', (e) => {
          e = e || window.event
          if (e.target.type === 'text') return;
          if (e.keyCode === 38 || e.keyCode === 37 || e.keyCode === 33) {
            onArrowPrev(onPrevPage)
          }
          else if (e.keyCode === 40 || e.keyCode === 39 || e.keyCode === 34) {
            onArrowNext(onNextPage)
          }
        })
      }
    })

    window.addEventListener('popstate', (e) => {
      goBack(e)
    });
  }

  render() {
    const {props: {onPrevPage, onNextPage, onAddRangeRef, currPage,
      onChangeRange, onChangeChapter, onLoadBookMark, onSaveReaderPosition, onChangeTextSize,
      onChangeTextColor, onChangeTextFont, onChangeViewMode, onLoadHighlight, onDeleteNote, rendition,
      activeHighlight, onAddBookMark, onAddNote, addNote, onSelectedColor, toggleActiveHighlight, onSelected,
      onSetTextSelected, onUpdateNote, onSearch, backButton, forwardButton, onBackButton, onForwardButton,
      onChangeRangeComplete, onChangeStart, bookReady, selectedHighlightColor, isSampleMode }} = this

    return (
        <div className="EpubReader">
          { bookReady ?
            <Navigation onChangeChapter={onChangeChapter} onLoadBookMark={onLoadBookMark}
                      onSaveReaderPosition={onSaveReaderPosition} onChangeTextSize={onChangeTextSize}
                      onChangeTextColor={onChangeTextColor} onChangeTextFont={onChangeTextFont}
                      onChangeViewMode={onChangeViewMode} onLoadHighlight={onLoadHighlight} onDeleteNote={onDeleteNote}
                      rendition={rendition} onAddBookMark={onAddBookMark} onSearch={onSearch}
                      onChangePage={onChangeChapter}/> :
            ''
          }
          <button
            className="navigation-prev-page icon-btn"
            onClick={() => onPrevPage()}
          ></button>
          <button
            className="navigation-next-page icon-btn"
            onClick={() => onNextPage()}
          ></button>
          <div
            id="viewer"
            className="spreads"
          ></div>
          <Pagination
            backButton={backButton}
            forwardButton={forwardButton}
            onBackButton={onBackButton}
            onForwardButton={onForwardButton}
            onAddRangeRef={onAddRangeRef}
            onChangeStart={onChangeStart}
            onChangeRange={onChangeRange}
            onChangeRangeComplete={onChangeRangeComplete}
            currPage={currPage}
          />
          {!isSampleMode ?
          <HighlightModal
            active={activeHighlight}
            loading={false}
            highlightModalTop={this.state.highlightModalTop}
            highlightModalLeft={this.state.highlightModalLeft}
            onAddBookMark={onAddBookMark}
            onAddNote={onAddNote}
            onSelectedColor={onSelectedColor}
            addNote={addNote}
            selectedColor={selectedHighlightColor}
            toggleActiveHighlight={toggleActiveHighlight}
            onDeleteNote={onDeleteNote}
            onSelected={onSelected}
            onSetTextSelected={onSetTextSelected}
            onUpdateNote={onUpdateNote}
            changeHighlighModalPosition={this.changeHighlighModalPosition}
          /> : ''}
        </div>
    )
  }
}

export const EpubReader = enhance(View)


// WEBPACK FOOTER //
// ./src/components/Formats/EpubReader/EpubReader.js